import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class MarketPlaceService {
  public marketPlace$: Subject<any> = new Subject();
  data: any = localStorage.getItem('marketplace');

  constructor() {
    this.marketPlace$.asObservable().subscribe((data) => {
      this.data = data;
    });
  }
}
